import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import PickleballRangeScale from '../../../../components/PickleballRangeScale';
import RangeFilter from './CoreComponents/RangeFilter';
import RadioFilter from './CoreComponents/RadioFilter';
import styles from '../../search.scss';
import { gameTypes, filterTypes } from '../../../../utils/constants';

const UtrFilterComponent = (props) => {
    const { isMemberFilter, filters, isClubFilter, filterInputs, handleUTRChange, showExpandedUtrFilter, handleUtrTypeClick, handleUtrTeamTypeClick, isHalfSteps, handleUtrReliabilityClick, 'data-testid': dataTestId } = props;
    const sportTypes = filters?.sportTypes;
    const players = 'players';
    const tennis = sportTypes?.tennis;
    const pickleball = sportTypes?.pickleball;
    const verifiedType = 'verified';
    const UTRNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
    filterInputs.utrMin = filterInputs.utrMin || 1;
    filterInputs.utrMax = filterInputs.utrMax || 16;
    if (showExpandedUtrFilter) {
        filterInputs.utrType = filterInputs.utrType || verifiedType;
        filterInputs.utrTeamType = filterInputs.utrTeamType || gameTypes.DOUBLES;
        filterInputs.utrReliability = filterInputs.utrReliability || null;
    }
    useEffect(() => {
        if (isMemberFilter) {
            handleUtrTeamTypeClick(
                'singles',
            );
        }
    },
        []);
    const utrRangeDisplay = (min, max) => {
        return `${min.toFixed(1)} - ${max.toFixed(1)}${max === 16 ? '+' : ''}`;
    };

    return (
        <>
            {((pickleball && !tennis && !isMemberFilter)) && (
                <>
                    <RangeFilter
                        title={`UTR-P Range`}
                        rangeKeyMin={1}
                        rangeKeyMax={10}
                        defaultValueArr={[filterInputs.utrMin, filterInputs.utrMax]}
                        isHalfSteps={isHalfSteps}
                        min={filterInputs.utrMin}
                        max={filterInputs.utrMax}
                        onChange={handleUTRChange}
                        customRangeDisplay={utrRangeDisplay}
                        isPickleballRangeFilter={pickleball}
                        pickleballMoreDesktopFilter={filterTypes.PICKLEBALL_FILTER}
                        data-testid={dataTestId && `${dataTestId}.pkb-range`}
                    />
                    <PickleballRangeScale data-testid={dataTestId && `${dataTestId}.pkb-scale`} />
                    <div className={styles.searchFilterModalDiv} />

                    {(filterInputs.type === players || isClubFilter) && (
                        <>
                            <div className="mt24 mb8" data-testid={dataTestId && `${dataTestId}.pkb-team-type-title`}>Singles/Doubles</div>
                            <RadioFilter
                                name="utrTeamType"
                                isPickleBallFilter={true}
                                options={[
                                    { label: 'singles', description: 'Singles' },
                                    { label: 'doubles', description: 'Doubles' },
                                ]}
                                selected={filterInputs.utrTeamType}
                                onChange={handleUtrTeamTypeClick}
                                handleUtrReliabilityClick={handleUtrReliabilityClick}
                                handleUtrTypeClick={handleUtrTypeClick}
                                data-testid={dataTestId && `${dataTestId}.pkb-team-type`}
                            />
                        </>
                    )}
                </>
            )}

            {(((tennis && !pickleball)) || isMemberFilter) && (
                <>
                    <RangeFilter
                        title={`UTR Range`}
                        rangeKeyMin={1}
                        rangeKeyMax={16}
                        defaultValueArr={[filterInputs.utrMin, filterInputs.utrMax]}
                        isHalfSteps={isHalfSteps}
                        min={filterInputs.utrMin}
                        max={filterInputs.utrMax}
                        onChange={handleUTRChange}
                        customRangeDisplay={utrRangeDisplay}
                        data-testid={dataTestId && `${dataTestId}.tennis-range`}
                    />
                    <div className="range-scale" data-testid={dataTestId && `${dataTestId}.tennis-scale`}>
                        {UTRNumbers.map(number => (
                            <div className="range-number" key={`utr-number-${number}`} data-testid={dataTestId && `${dataTestId}.tennis-scale.number-${number}`}>{number}</div>
                        ))}
                    </div>
                    <div className="range-texts" />
                    {showExpandedUtrFilter && (
                        <>
                            <div className="mt24 mb8" data-testid={dataTestId && `${dataTestId}.rating-type-title`}>Rating Type</div>
                            <RadioFilter
                                name="utrType"
                                options={[
                                    { label: 'verified', description: 'Verified UTR' },
                                    { label: 'unverified', description: 'UTR' },
                                ]}
                                selected={filterInputs.utrType}
                                onChange={handleUtrTypeClick}
                                data-testid={dataTestId && `${dataTestId}.rating-type`}
                            />
                            <div className="mt24 mb8" data-testid={dataTestId && `${dataTestId}.tennis-team-type-title`}>Singles/Doubles</div>
                            <RadioFilter
                                name="utrTeamType"
                                options={[
                                    { label: 'singles', description: 'Singles' },
                                    { label: 'doubles', description: 'Doubles' },
                                ]}
                                selected={filterInputs.utrTeamType}
                                onChange={handleUtrTeamTypeClick}
                                data-testid={dataTestId && `${dataTestId}.tennis-team-type`}
                            />
                            <div className="mt24 mb8" data-testid={dataTestId && `${dataTestId}.reliability-title`}>Reliability</div>
                            <RadioFilter
                                name="utrReliability"
                                options={[
                                    { label: 'rated', description: 'Rated' },
                                    { label: 'projected', description: 'Projected' },
                                    { label: 'unrated', description: 'Unrated' },
                                ]}
                                selected={filterInputs.utrReliability}
                                onChange={handleUtrReliabilityClick}
                                data-testid={dataTestId && `${dataTestId}.reliability`}
                            />
                        </>
                    )}
                </>
            )}
        </>
    );
};
UtrFilterComponent.propTypes = {
    filterInputs: PropTypes.instanceOf(Object).isRequired,
    filters: PropTypes.instanceOf(Object).isRequired,
    handleUTRChange: PropTypes.func,
    showExpandedUtrFilter: PropTypes.bool,
    handleUtrTypeClick: PropTypes.func,
    handleUtrTeamTypeClick: PropTypes.func,
    handleUtrReliabilityClick: PropTypes.func,
    isHalfSteps: PropTypes.bool,
    isMemberFilter: PropTypes.bool,
    isClubFilter: PropTypes.bool,
    'data-testid': PropTypes.string,
};

UtrFilterComponent.defaultProps = {
    isHalfSteps: false,
    isClubFilter: false,
    showExpandedUtrFilter: false,
    handleUTRChange: () => { },
    handleUtrReliabilityClick: () => { },
    handleUtrTeamTypeClick: () => { },
    handleUtrTypeClick: () => { },
    isMemberFilter: false,
    'data-testid': undefined,
};
export default UtrFilterComponent;
